/* Maison RHB: hover magnifier for narrow browser windows used with a mouse or trackpad.
   (Wide windows use the ImageZoom desktop handlers in app.js.) */
(function () {
  var current = null;
  var narrow = window.matchMedia("(max-width: 767px)");

  function hiRes(src) {
    try {
      var u = new URL(src, window.location.href);
      u.searchParams.set("width", "3000");
      return u.toString();
    } catch (err) {
      return src;
    }
  }

  function contentRect(img) {
    var r = img.getBoundingClientRect();
    var nw = img.naturalWidth || r.width;
    var nh = img.naturalHeight || r.height;
    var fit = getComputedStyle(img).objectFit;
    if (fit !== "contain" && fit !== "cover") return r;
    var imgRatio = nw / nh;
    var useWidth = fit === "contain" ? imgRatio > r.width / r.height : imgRatio < r.width / r.height;
    var w = useWidth ? r.width : r.height * imgRatio;
    var h = useWidth ? r.width / imgRatio : r.height;
    return { left: r.left + (r.width - w) / 2, top: r.top + (r.height - h) / 2, width: w, height: h };
  }

  function position(box, img, overlay, x, y) {
    var c = contentRect(img);
    if (!c.width || !c.height) return;
    var b = box.getBoundingClientRect();
    var fx = Math.min(1, Math.max(0, (x - c.left) / c.width));
    var fy = Math.min(1, Math.max(0, (y - c.top) / c.height));
    var natural = Number(overlay.dataset.naturalWidth) || img.naturalWidth || c.width * 2.5;
    var zoom = Math.min(3, Math.max(2, natural / c.width));
    zoom = Math.max(zoom, b.width / c.width, b.height / c.height);
    var w = c.width * zoom;
    var h = c.height * zoom;
    var px = Math.min(0, Math.max(b.width - w, x - b.left - fx * w));
    var py = Math.min(0, Math.max(b.height - h, y - b.top - fy * h));
    overlay.style.backgroundSize = w + "px " + h + "px";
    overlay.style.backgroundPosition = px + "px " + py + "px";
  }

  function clear() {
    if (!current) return;
    var o = current.overlay;
    o.style.opacity = "0";
    setTimeout(function () {
      if (o.parentNode && o.style.opacity === "0") o.remove();
    }, 200);
    current = null;
  }

  document.addEventListener(
    "pointermove",
    function (e) {
      if (e.pointerType !== "mouse" || !narrow.matches) {
        clear();
        return;
      }
      var box = e.target.closest && e.target.closest('.slider__slide [x-data="ImageZoom"]');
      if (!box) {
        clear();
        return;
      }
      var img = Array.prototype.find.call(box.querySelectorAll("img"), function (i) {
        return i.offsetWidth > 0;
      });
      if (!img) return;
      var src = img.currentSrc || img.src;
      if (!current || current.box !== box || current.src !== src) {
        clear();
        if (getComputedStyle(box).position === "static") box.style.position = "relative";
        var overlay = document.createElement("div");
        overlay.className = "zoomed-img maison-hover-zoom";
        overlay.setAttribute("aria-hidden", "true");
        overlay.style.cssText =
          "position:absolute;inset:0;width:100%;height:100%;z-index:50;pointer-events:none;" +
          "background-repeat:no-repeat;opacity:0;transition:opacity .18s ease;background-color:#fff;" +
          'background-image:url("' + src + '")';
        box.appendChild(overlay);
        current = { box: box, img: img, overlay: overlay, src: src, x: e.clientX, y: e.clientY };
        var hi = hiRes(src);
        var pre = new Image();
        var state = current;
        pre.onload = function () {
          overlay.dataset.naturalWidth = pre.naturalWidth;
          overlay.style.backgroundImage = 'url("' + hi + '")';
          if (current === state) position(box, img, overlay, state.x, state.y);
        };
        pre.src = hi;
        requestAnimationFrame(function () {
          overlay.style.opacity = "1";
        });
      }
      current.x = e.clientX;
      current.y = e.clientY;
      position(box, img, current.overlay, e.clientX, e.clientY);
    },
    { passive: true }
  );

  document.addEventListener("pointerdown", function (e) {
    if (e.pointerType === "mouse") clear();
  });
  window.addEventListener("scroll", clear, { passive: true });
})();
